import { render, staticRenderFns } from "./AddGroupPopupBox.vue?vue&type=template&id=0527e413&scoped=true&"
import script from "./AddGroupPopupBox.vue?vue&type=script&lang=js&"
export * from "./AddGroupPopupBox.vue?vue&type=script&lang=js&"
import style0 from "@/assets/css/popup.css?vue&type=style&index=0&id=0527e413&scoped=true&lang=css&"
import style1 from "./AddGroupPopupBox.vue?vue&type=style&index=1&id=0527e413&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0527e413",
  null
  
)

export default component.exports